import authComponent from "./auth.component";
import signinComponent from "./signin/signin.component";
import acceptInviteComponent from "./accept-invite/accept-invite.component";
import resetPasswordComponent from "./reset-password/reset-password.component";
import {AuthRouter} from "./auth.router";

import passwordModule from "./password/password";
import twoFactorComponent from "./two-factor/two-factor.component";
import twoFactorSuccessComponent from "./two-factor/two-factor-success.component";

export const AuthModule = angular
	.module("auth", [
		passwordModule.name
	])
	.config(AuthRouter)
	.component("auth", authComponent)
	.component("signin", signinComponent)
	.component("acceptInvite", acceptInviteComponent)
	.component("resetPassword", resetPasswordComponent)
	.component("twoFactor", twoFactorComponent)
	.component("twoFactorSuccess", twoFactorSuccessComponent);



// WEBPACK FOOTER //
// ./sources/components/auth/auth.js